<template>
  <div>
    <b-form-group
      id="fieldset-1"
      :description="description"
      label="Start typing a first or last name"
      label-for="input-1"
      :invalid-feedback="invalidFeedback"
      :valid-feedback="validFeedback"
      :state="state"
    >
      <b-form-input
        id="input-1"
        type="text"
        autocomplete="off"
        @keyup="triggerSearch()"
        v-model="searchString"
        :state="state"
        :autofocus="true"
        trim
      ></b-form-input>
    </b-form-group>
    <b-form-select
    v-if="supressFilter == false"
      v-model="filter"
      :options="filterOptions"
      @change="triggerSearch()"
    ></b-form-select>
    <div style="height :20px"></div>
    <b-list-group>
      <b-list-group-item
        v-for="(item, index) in results"
        :key="index"
        @click="actionSelected(item.pk, item.firstName, item.lastName)"
        >{{ item.firstName }} {{ item.lastName }}
      </b-list-group-item>
    </b-list-group>
    <div v-if="results" style="height:20px"></div>
  </div>
</template>

<script>
import axios from "axios";
// this used in local dev set to empty string for productoin
/* exported variableName */
export default {
  props: {
    action: {
      type: String,
      required: false,
    },
  },
  mounted: function() {
    this.reset();
  },
  computed: {
    urlPrefix() {
      return this.$store.getters.urlPrefix;
    },
    supressFilter() {
      if (this.$route.params.supressFilter != null) {
        return this.$route.params.supressFilter;
      }
      return false;
    },
    actionComp(){
      //This is to allow either a prop for action or route param
      if (this.$route.params.action != null) {
        return this.$route.params.action;
      }else{return this.action;}

    },
    state() {
      if (this.searchString.length == 0) {
        return null;
      }
      return this.searchString.length >= 3 ? true : false;
    },
    invalidFeedback() {
      if (this.searchString.length > 3) {
        return "";
      } else if (this.searchString.length > 0) {
        return "Enter at least 3 characters";
      } else {
        return "Please enter something to search for";
      }
    },
    validFeedback() {
      return this.state === true ? "Thank you" : "";
    },
    description() {
      if (this.results != null) {
        var countResults = Object.keys(this.results).length;
        if (countResults > 0) {
          return countResults + " Members found";
        }
      }
      if (this.searchString.length > 2) {
        return "No members found";
      }
      return "";
    },
  },
  data() {
    return {
      searchString: "",
      filter: "active",
      filterOptions: [
        { value: "active", text: "Filter by active members" },
        { value: "inactive", text: "Filter by inactive members" },
        {
          value: "parent",
          text: "Filter by parents and other responsible people",
        },
      ],
      results: null,
      error: "",
      personId: 10,
    };
  },
  //end of data start of method
  methods: {
    triggerSearch() {
      if (this.searchString.length >= 3) {
        // call query method now
        let post_url =
          this.urlPrefix +
          "api/people_search/?search_string=" +
          this.searchString +
          "&search_filter=" +
          this.filter;
        const djangoAuthToken = localStorage.getItem("djangoAccessToken");
        const headers = {
          headers: { Authorization: "Bearer " + djangoAuthToken },
        };
        axios
          .get(post_url, headers)
          .then((response) => {
            this.results = response.data;
          })
          .catch((error) => {
            this.error = "Unable to load project names " + error;
          });
      }
      // if less than 3 clear the results e.g someone backspaces to change a name
      else {
        this.results = {};
      }
    },
    reset() {
      // resets all data for a clean run next time
      this.results = null;
      this.filter = "active";
      this.searchString = "";
      this.error = "";
    },
    actionSelected(id, firstName, lastName) {
      // eslint-disable-next-line no-console
      //console.log("pressed button" + id);
      if (this.actionComp == "navToPerson") {
        this.$bvModal.hide("modal-search");
        this.$router.push("/person/" + id);
      } else if (this.actionComp == "addFnf") {
        this.$store.dispatch("addedFriend", {
          id: id,
          firstName: firstName,
          lastName: lastName,
        });
      } else if (this.actionComp =="addAttendance") // Nav to project picker 
      {
        this.$router.push({name:"soos-project-picker",params:{pk:id,firstName:firstName,lastName:lastName,navTo:'staff-operated-signin',navBack:'staff-operated-signin'}})

      }
    },
  }, //End of methods
};
</script>
